function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component } from 'react';
import _ from 'underscore';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Databases = /*#__PURE__*/function (_Component) {
  function Databases(props) {
    var _this;
    _classCallCheck(this, Databases);
    _this = _callSuper(this, Databases, [props]);
    _this.state = {
      type: '',
      currentlySelectedDatabases: []
    };
    _this.preSelectedDbs = _this.props.preSelectedDbs;
    _this.databases = _this.databases.bind(_this);
    _this.nselected = _this.nselected.bind(_this);
    _this.categories = _this.categories.bind(_this);
    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.renderDatabases = _this.renderDatabases.bind(_this);
    _this.renderDatabase = _this.renderDatabase.bind(_this);
    return _this;
  }
  _inherits(Databases, _Component);
  return _createClass(Databases, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      // If there's only one database, select it.
      if (this.databases() && this.databases().length === 1 && this.state.currentlySelectedDatabases.length === 0) {
        this.setState({
          currentlySelectedDatabases: this.databases()
        });
      }
      if (this.preSelectedDbs && this.preSelectedDbs.length !== 0) {
        this.setState({
          currentlySelectedDatabases: this.preSelectedDbs
        });
        this.preSelectedDbs = null;
      }
      var type = this.state.currentlySelectedDatabases[0] ? this.state.currentlySelectedDatabases[0].type : '';
      if (type != this.state.type) {
        this.setState({
          type: type
        });
        this.props.onDatabaseTypeChanged(type);
      }
      if (prevState.currentlySelectedDatabases !== this.state.currentlySelectedDatabases) {
        // Call the prop function with the new state
        this.props.onDatabaseSelectionChanged(this.state.currentlySelectedDatabases);
      }
    }
  }, {
    key: "databases",
    value: function databases(category) {
      var databases = this.props.databases;
      if (category) {
        databases = _.select(databases, function (database) {
          return database.type === category;
        });
      }
      return _.sortBy(databases, 'title');
    }
  }, {
    key: "nselected",
    value: function nselected() {
      return this.state.currentlySelectedDatabases.length;
    }
  }, {
    key: "categories",
    value: function categories() {
      return _.uniq(_.map(this.props.databases, _.iteratee('type'))).sort();
    }
  }, {
    key: "handleToggle",
    value: function handleToggle(toggleState, type) {
      switch (toggleState) {
        case '[Select all]':
          this.setState({
            currentlySelectedDatabases: this.databases(type)
          });
          break;
        case '[Deselect all]':
          this.setState({
            currentlySelectedDatabases: []
          });
          break;
      }
    }
  }, {
    key: "renderDatabases",
    value: function renderDatabases(category) {
      // Panel name and column width.
      var panelTitle = category[0].toUpperCase() + category.substring(1).toLowerCase() + ' databases';
      var columnClass = this.categories().length === 1 ? 'col-span-2' : '';

      // Toggle button.
      var toggleState = '[Select all]';
      var toggleClass = 'px-2 text-base md:text-lg';
      var toggleShown = this.databases(category).length > 1;
      var toggleDisabled = this.state.type && this.state.type !== category;
      if (toggleShown && toggleDisabled) {
        toggleClass += ' text-gray-400';
      } else {
        toggleClass += ' text-seqblue';
      }
      if (!toggleShown) toggleClass += ' hidden';
      if (this.nselected() === this.databases(category).length) {
        toggleState = '[Deselect all]';
      }

      // JSX.
      return /*#__PURE__*/_jsx("div", {
        className: columnClass,
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("div", {
            className: "border-b border-seqorange mb-2",
            children: [/*#__PURE__*/_jsx("h4", {
              className: "font-medium inline text-base md:text-lg",
              children: panelTitle
            }), /*#__PURE__*/_jsx("button", {
              type: "button",
              className: toggleClass,
              disabled: toggleDisabled,
              onClick: function () {
                this.handleToggle(toggleState, category);
              }.bind(this),
              children: toggleState
            })]
          }), /*#__PURE__*/_jsx("ul", {
            className: 'databases ' + category,
            children: _.map(this.databases(category), _.bind(function (database, index) {
              return /*#__PURE__*/_jsx("li", {
                className: "text-base md:text-lg leading-tight md:leading-tight",
                children: this.renderDatabase(database)
              }, 'DB_' + category + index);
            }, this))
          })]
        })
      }, 'DB_' + category);
    }
  }, {
    key: "handleDatabaseSelectionClick",
    value: function handleDatabaseSelectionClick(database) {
      var isSelected = this.state.currentlySelectedDatabases.some(function (db) {
        return db.id === database.id;
      });
      if (isSelected) {
        this.setState(function (prevState) {
          return {
            currentlySelectedDatabases: prevState.currentlySelectedDatabases.filter(function (db) {
              return db.id !== database.id;
            })
          };
        });
      } else {
        this.setState(function (prevState) {
          return {
            currentlySelectedDatabases: [].concat(_toConsumableArray(prevState.currentlySelectedDatabases), [database])
          };
        });
      }
    }
  }, {
    key: "renderDatabase",
    value: function renderDatabase(database) {
      var isDisabled = this.state.type && this.state.type !== database.type;
      var isChecked = this.state.currentlySelectedDatabases.some(function (db) {
        return db.id === database.id;
      });
      return /*#__PURE__*/_jsxs("label", {
        className: isDisabled && 'database text-gray-400' || 'database text-seqblue',
        children: [/*#__PURE__*/_jsx("input", {
          type: "checkbox",
          name: "databases[]",
          value: database.id,
          "data-type": database.type,
          disabled: isDisabled,
          checked: isChecked,
          className: "checkbox-database",
          onChange: _.bind(function () {
            this.handleDatabaseSelectionClick(database);
          }, this)
        }), ' ' + (database.title || database.name)]
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {
        className: "my-6 grid md:grid-cols-2 gap-4",
        children: _.map(this.categories(), this.renderDatabases)
      });
    }
  }]);
}(Component);